/* Surrounding Areas Mapping */

// When page loads, go through each input type and add the selected areas
//   areas will be assigned a "searchType" property
//window.surroundingAreasMapping = new function () {
define(['jquery', 'c21/internationalization', 'c21/track', 'c21/ajax', 'c21/results'], function ($, internationalization, track, ajax, results) {
   "use strict";

   return function () {
      var self = this,

         m_mapExistingZoom = "",
         m_mapExistingBounds = "",

         m_oSelectedAreas = {},
         m_oSurroundingAreaByLid = {},
         m_oSelectedAreasByLid = {},

         // Used with #surroundingAreaSearchType string
         LID_STRING_LOOKUP = {
            "City": 0,
            "Neighborhood": 1,
            "Zipcode": 2
         },

         LID_TYPE = {
            TYPE_CITY: 0,
            TYPE_NEIGHBORHOOD: 1,
            TYPE_ZIPCODE: 2
         },

         m_map,
         m_page,

         m_oSurroundingAreas = {},
         m_strPrimaryAreaLocation = "",
         surroundingAreaTooltipTopPosition = 200,

         m_aStartingSelectedAreas = [],

         /* PRIVATE METHODS
          * ==================================*/

         initSelectedAreas = function() {
            var strCities = $("#selectedCities").val(),
               strNeighborhoods = $("#selectedNeighborhoods").val(),
               strZipcodes = $("#selectedZipcodes").val(),
               strLocations = "",
               aSelectedAreas;

            strLocations = appendStringWithSeperator(strLocations, strCities);
            strLocations = appendStringWithSeperator(strLocations, strNeighborhoods);
            strLocations = appendStringWithSeperator(strLocations, strZipcodes);

            if (strLocations === "") {
               aSelectedAreas = [];
            } else {
               aSelectedAreas = strLocations.split(",");
            }

            m_aStartingSelectedAreas = aSelectedAreas;

            $.each(m_aStartingSelectedAreas, function(i, strLocation) {
               var area = m_oSurroundingAreaByLid[strLocation];
               addSelectedSurroundingArea(area.lid);
            });
         },

         getSearchTypeString = function() {
            var strSearchType = $("#surroundingAreaSearchType").val() || "City";
            return strSearchType;
         },

         getAreaCheckbox = function(strLid) {
            return $("#surroundingArea_" + strLid);
         },

         getCheckboxLabel = function(jCheckbox) {
            return jCheckbox.parent().parent().parent();
         },

         getAreaLabel = function(strLid) {
            return getCheckboxLabel(getAreaCheckbox(strLid));
         },

         getRadioContainer = function(jRadio) {
            return jRadio.parents(".searchType");
         },

         togglePanelControls = function(bShow) {
            $("#panelToggleControl, #fullListToggleControl").toggle(bShow);
         },

         /**
          * Build the Surrounding Areas ToolTip
          */
         showSurroundingAreasToolTip = function() {
            // Update the hidden fields for the surrounding areas based on the type
            self.updateCurrentAreaSelections();

            $("#SurroundingAreasModalDiv").show();
            togglePanelControls(false);

            // Search type radios
            var jTooltip = $("#surroundingAreasToolTip"),
               jAllRadioButtons = jTooltip.find("input:radio"),
               jAllCheckboxes = jTooltip.find("input:checkbox"),
               jAllContainers = $();

            jAllRadioButtons.uniform();
            jAllCheckboxes.uniform();
            jTooltip.show();
            $.uniform.update();

            jAllRadioButtons.each(function () {
               var jRadio = $(this),
                  jContainer = getRadioContainer(jRadio);

               jContainer.toggleClass("selected", jRadio.prop("checked"));
               jAllContainers.add(jContainer);

               jRadio.click(function() {
                  if (!jRadio.prop("checked")) return;

                  jAllContainers.removeClass("selected");
                  jContainer.addClass("selected");

                  $("#surroundingAreaSearchType").val(jRadio.val());
                  $("#switchAreaSearchType").val("Y");
                  track.doEvent('Surrounding Areas', 'Select Search Type', jRadio.val()); 
                  
                  self.loadSurroundingAreasModal();
               });
            });

            // Search type location checkboxes
            jAllCheckboxes.click(function () {
               var jCheckbox = $(this),
                  bChecked = jCheckbox.prop("checked"),
                  strLid = jCheckbox.val(),
                  strLocationName = getCheckboxLabel(jCheckbox).find(".checkLabel").html();

               if (bChecked) {
                  self.gaTrackAddArea(strLocationName);
                  addSelectedSurroundingArea(strLid);
               } else {
                  self.gaTrackRemoveArea(strLocationName);
                  removeSelectedSurroundingArea(strLid);
               }

               jCheckbox.parent().parent().parent().toggleClass("selected", bChecked);
               m_map.setSurroundingAreaChecked(strLid, bChecked);
            });

            $(".surroundingCheckLabel").hover(function () {
               var jCheckbox = $(this);

               // Don't bother if the label is already selected
               if (jCheckbox.hasClass("selected")) return;

               jCheckbox.addClass("hover");

               var strLid = jCheckbox.find("input:checkbox").val();
               m_map.setSurroundingAreaHover(strLid, true);
            }, function () {
               var jCheckbox = $(this);
               jCheckbox.removeClass("hover");

               var strLid = jCheckbox.find("input:checkbox").val();
               m_map.setSurroundingAreaHover(strLid, false);
            });

            initMyPlacesLink();

            // Set the selected surrounding area check boxes
            setSelectedSurroundingAreas();

            m_map.renderSurroundingAreas();

            var jRefine = $("#surroundingAreasLiqMap"),
                jSurround = $("#surroundingAreasToolTip"),
                pos = jRefine.position(),
                jTip = jSurround.find(".contentTip");

            jTip.css("top", surroundingAreaTooltipTopPosition);

            jSurround.css({
                top: pos.top -
                    jTip.position().top
            });

         },

         /**
          * Initialize my places link
          */
         initMyPlacesLink = function() {
            // Toggle my places
            var jSection = $("#myPlacesSection");

            // MyPlaces link hover state
            jSection.hover(function () {
               jSection.addClass("hover");
            }, function () {
               jSection.removeClass("hover");
            });

            jSection.find(".myplaceLink, .myplaceIcon").click(function () {
               if (jSection.hasClass("selected")) {
                track.doEvent('Surrounding Areas', 'Turn off My Places');  
                turnOffMyPlaces();
                   m_map.disableMyC21Places();
               } else {
                track.doEvent('Surrounding Areas', 'Turn on My Places');  
                turnOnMyPlaces();
                   m_map.enableMyC21Places();    
                   $("#myPlacesToolInstructions").removeClass("active");
               }
            });
            
            if (m_map.isMyPlacesEnabled()) {
              turnOnMyPlaces();
            } else {
              turnOffMyPlaces();
            }
            
            // Hide My Places Tool if there is no Database and Session Availability
            if (window.databaseAvailable && (window.sessionAvailable || (!window.sessionAvailable && window.sessionAuthenticated))) {
            jSection.show();	 
            } else {
               jSection.hide(); 
            }
         },

         /**
          * Turn on My Places
          */
         turnOnMyPlaces = function() {
            var jSection = $("#myPlacesSection");
            var jMyPlaceLink = $(".myplaceLink");
            jMyPlaceLink.text(internationalization.getString("Turn off My Places"));
            jSection.addClass("selected");
         },
         
         /**
          * Turn off My Places
          */
         turnOffMyPlaces = function() {
            var jSection = $("#myPlacesSection");
            var jMyPlaceLink = $(".myplaceLink");
            jMyPlaceLink.text(internationalization.getString("Turn on My Places"));
            jSection.removeClass("selected");
         },

         /**
          * Set the user selected surrounding area checkboxes
          */
         setSelectedSurroundingAreas = function() {
            var jTooltip = $("#surroundingAreasToolTip"),
               jCheckboxes = jTooltip.find("input:checkbox"),
               jSelections = self.getSelectionsBox(),
               strLocations = jSelections.val();
            
            // Clear all the previous selections
            jCheckboxes.each(function () {
               var jThis = $(this),
                  jContainer = jThis.parent().parent().parent();

               if (strLocations && arrayContains(strLocations.split(","), jThis.val())) {
                  jContainer.addClass("selected");
                  jThis.prop("checked", true);
               } else {
                  jContainer.removeClass("selected");
                  jThis.prop("checked", false);
               }
            });

            $.uniform.update();
         },

         /**
          * Remove string value from comma seperated values of element
          */
         removeStringFromElement = function(element, strLid) {
            var strLocations = element.val();
            if (strLocations) {
               if (strLocations.indexOf(strLid + ",") !== -1) {
                  strLocations = strLocations.replace(strLid + ",", "");
               } else if (strLocations.indexOf("," + strLid) !== -1) {
                  strLocations = strLocations.replace("," + strLid, "");
               } else {
                  strLocations = strLocations.replace(strLid, "");
               }
            }
            element.val(strLocations);
         },

         /**
          * Checks if an array contains a value and returns true/false
          */
         arrayContains = function(arr, findValue) {
            var i = arr.length;

            while (i--) {
               if (arr[i] === findValue) return true;
            }
            return false;
         },

         /**
          * Hide the Surrounding areas tooltip/modal
          */
         hideSurroundingAreasToolTip = function(bRefine) {
            $("#SurroundingAreasModalDiv").hide();
            togglePanelControls(true);
            
            // Perform the property search
            var aSelectedAreas = self.getSelectedSurroundingAreas();
            results.changeSurroundingAreas(0, aSelectedAreas, bRefine);

            if (aSelectedAreas.length !== 0) {
               track.doEvent('Surrounding Areas', 'Added areas to search', aSelectedAreas.length);   
            }
         },
         
         /**
          * Append String with Seperator
          */
         appendStringWithSeperator = function(mainstr, newstr) {
            if (mainstr === "") {
               mainstr = newstr;
            } else if (newstr !== "") {
               mainstr = mainstr + "," + newstr;
            }

            return mainstr;
         },

         /**
          * Add the selected surrounding area to its appropriate search type
          */
         addSelectedSurroundingArea = function(strLid) {
            // Do not add twice
            if (m_oSelectedAreasByLid[strLid]) return;

            var area = m_oSurroundingAreaByLid[strLid],
               jSelections = self.getSelectionsBox(strLid),
               strLocations = jSelections.val();

            m_oSelectedAreas[area.location] = area;
            m_oSelectedAreasByLid[strLid] = area;

            if (strLocations === null || strLocations === "") {
               strLocations = strLid;
            } else {
               strLocations = strLocations + "," + strLid;
            }

            jSelections.val(strLocations);
         },

         /**
          * Remove the selected surrounding area from its appropriate search type
          */
         removeSelectedSurroundingArea = function(strLid) {
            // Do not remove if it isn't selected
            if (!m_oSelectedAreasByLid[strLid]) return;

            var area = m_oSurroundingAreaByLid[strLid],
               jSelections = self.getSelectionsBox(strLid),
               strLocations = jSelections.val();

            delete m_oSelectedAreas[area.location];
            delete m_oSelectedAreasByLid[strLid];

            if (strLocations) {
               if (strLocations.indexOf(strLid + ",") !== -1) {
                  strLocations = strLocations.replace(strLid + ",", "");
               } else if (strLocations.indexOf("," + strLid) !== -1) {
                  strLocations = strLocations.replace("," + strLid, "");
               } else {
                  strLocations = strLocations.replace(strLid, "");
               }
            }
            jSelections.val(strLocations);
         },

         /**
          * Initialize the surrounding area tool tip
          */
         initToolTip = function() {
            //var jLiquidBodyMiddle = $(".LiquidBodyMiddle"),
            //   jLiquidBodyMain = $(".LiquidBodyMain"),
            var jSurroundingAreaLink = $("#surroundingAreasLiqMap");

            //Surrounding Area Main Link Hover States
            jSurroundingAreaLink.hover(function () {
               $(this).addClass("hover");
            }, function () {
               $(this).removeClass("hover");
            });

            //Click Surrounding Areas Main Link
            jSurroundingAreaLink.click(function () {
               if (jSurroundingAreaLink.hasClass("selected")) {
                  track.doEvent('Surrounding Areas', 'Close Surrounding Areas Tool'); 
                  $(".mapToolsArea").show();
                  $("#typeContainer").show();
                  $(".OverlaysTL").show();
                  $("#BodyRightLane").show();
                  $("#mapContainer").css("top", "31px");
                  if($("#bottomMapTools").hasClass("selected")) {
                     $("#bottomMapToolsDropDown").show();
                  }
                  
                  var strSelectedAreas = self.getSelectedSurroundingAreas().join(),
                     strStartingAreas = m_aStartingSelectedAreas.join(),
                     bRefine = true;

                  // If the selected areas have not been changed,
                  // restore the zoom and bounds to the state before surrounding areas was selected
                  if (strSelectedAreas === strStartingAreas && m_mapExistingZoom !== "" && m_mapExistingBounds !== "") {
                     m_map.setMapView(m_mapExistingZoom, m_mapExistingBounds);
                     bRefine = false;
                  }

                  // This MUST be set before map begins resizing
                  // (or the map will zoom to the wrong location)
                  $("#searchLocationLIDS").val(strSelectedAreas);
                              
                  // Clear the surrounding map layer
                  m_map.clearSurroundingAreas();

                  // Refresh and show the heat map
                  m_map.refreshHeatmap();            
                  
                  // Refresh and show POI
                  m_map.refreshPOI();

                  m_page.openCenterLane();
                  jSurroundingAreaLink.removeClass("selected");

                  // Hide the surrounding area tool tip
                  hideSurroundingAreasToolTip(bRefine);
               } else {
                  //m_page.onReady(function() {
                     // Close the school search modal
                     $(window).trigger("refinemodalopen");

                     // Capture the zoom and bounds of the map state before surrounding areas is selected.
                     m_mapExistingZoom = m_map.getZoom();
                     m_mapExistingBounds = m_map.getBounds();
                     
                     track.doEvent('Surrounding Areas', 'Open Surrounding Areas Tool'); 
                     jSurroundingAreaLink.addClass("selected");
                     $(".mapToolsArea").hide();
                     $("#typeContainer").hide();
                     $(".OverlaysTL").hide();
                     $("#BodyRightLane").hide();
                     $("#mapContainer").css("top", "0px");
                     $("#bottomMapToolsDropDown").hide();
                     
                     // Clear all the other layers
                     m_map.clearAll();
                     m_map.clearTooltips();
                     m_map.clearHeatMap();               
                     m_map.clearPOI();               
                     m_map.clearSchools();               
                     
                     // Close the my places instructions
                     $("#myPlacesToolInstructions").removeClass("active");
                     $("#myPlacesTool").removeClass("selected");

                     // Load the surrounding areas modal
                     $("#switchAreaSearchType").val("");

                     m_page.closeCenterLane(function() {
                        self.loadSurroundingAreasModal();
                     }, true);
                  //});
               }
            });
         };

      /* PUBLIC METHODS
       * ==================================*/

      /**
       * Initialize
       */
      this.onPageReady = function (page) {
         m_page = page;
         m_map = page.getMap();

         // Initialize the tool tip
         $("#refineSearch").on("portalAjaxLoadEvent", initToolTip);
         initToolTip();

         // Cheating
         window.surroundingAreasMapping = self;

         $(window).on("refinemodalopen", closeWindow);
      };

      /**
       * Clear the selected surrounding areas
       */
      this.clearSurroundingAreas = function () {
         m_oSelectedAreas = {};
         m_oSelectedAreasByLid = {};
         $("#selectedCities").val("");
         $("#selectedNeighborhoods").val("");
         $("#selectedZipcodes").val("");
      };

      /**
       * Re-position tool tip modal position when the current search box
       * is expanded
       */
      this.updateTooltipPosition = function (iHeightDiff) {
         var topPosition = surroundingAreaTooltipTopPosition + iHeightDiff,
            jSearchListSection = $("#searchListSection");

         if (jSearchListSection.length === 0) return;

         var iSearchListTop = jSearchListSection.position().top,
            iSearchListBottom = iSearchListTop + jSearchListSection.height(),
            jContentTip = $("#surroundingAreasToolTip .contentTip"),
            iContentTipHeight = jContentTip.height();

         jContentTip.stop().animate({
            top: topPosition
         }, {
            step: function (iNow) {
               if (iNow > (iSearchListBottom - iContentTipHeight)) {
                  jContentTip.hide();
                  return;
               }

               if (iNow < iSearchListTop) {
                  jContentTip.hide();
                  return;
               }

               jContentTip.show();
            }
         });
      };

      /**
       * Add surrounding areas, completely replacing the previous set
       * @param oData
       */
      this.addData = function (oData) {
         m_oSurroundingAreas = oData.locations;
         $.extend(m_oSurroundingAreas, m_oSelectedAreas);

         m_oSurroundingAreaByLid = {};
         $.each(m_oSurroundingAreas, function(strLoc, area) {
            m_oSurroundingAreaByLid[area.lid] = area;
         });
      };

      /**
       * Add a single primary area location
       * @param strLocation
       * @param oArea
       */
      this.addPrimaryData = function (oData) {
         $.each(oData.locations, function (strLocation, oArea) {
            m_strPrimaryAreaLocation = strLocation;
            self.updateArea(strLocation, oArea);
         });
      };

      this.updateArea = function(strLocation, oArea) {
         if (m_oSurroundingAreas[strLocation]) {
            $.extend(m_oSurroundingAreas[strLocation], oArea);
         } else {
            m_oSurroundingAreas[strLocation] = oArea;
         }
      };

      /**
       * Add surrounding areas to existing surrounding areas
       * @param oData
       */
      this.addSearchCountsData = function (oData) {
         $.each(oData.locations, function (strLocation, oArea) {
            self.updateArea(strLocation, oArea);
         });
      };

      /**
       * Get all surrounding areas
       */
      this.getSurroundingAreas = function () {
         return m_oSurroundingAreas;
      };

      /**
       * Get the primary area
       */
      this.getPrimaryArea = function () {
         return m_oSurroundingAreas[m_strPrimaryAreaLocation];
      };

      /**
       * Get the primary area's location (ex: "PHOENIX, AZ")
       */
      this.getPrimaryAreaLocation = function () {
         return m_strPrimaryAreaLocation;
      };

      /**
       * Get a surrounding by location
       * @param strLocation
       */
      this.getSurroundingArea = function (strLocation) {
         return m_oSurroundingAreas[strLocation];
      };

      function closeWindow () {
         if ($('#surroundingAreasLiqMap').hasClass("selected")) {
            $('#surroundingAreasLiqMap').trigger('click');
         }
      }

      /**
       * Close Modal
       */
      this.closeWindow = closeWindow;

      /**
       * Checks if the passed in area has been selected or not
       * @param strLid
       * @return boolean
       */
      this.isAreaSelected = function (strLid) {
         return (m_oSelectedAreasByLid[strLid] !== undefined);
      };

      /**
       * Toggle the surrounding area
       */
      this.toggleSelectedSurroundingArea = function (strLid) {
         var jCheckbox = getAreaCheckbox(strLid),
            jLabel = getCheckboxLabel(jCheckbox),
            bSelected = self.isAreaSelected(strLid),
            area = m_oSurroundingAreaByLid[strLid],
            strDisplayName = area.dislayName;

         if (bSelected) {
            self.gaTrackRemoveArea(strDisplayName); 
            removeSelectedSurroundingArea(strLid);
            bSelected = false;
         } else {
            self.gaTrackAddArea(strDisplayName); 
            addSelectedSurroundingArea(strLid);
            bSelected = true;
         }

         if (jCheckbox.length > 0) {
            jCheckbox.prop("checked", bSelected);
            jLabel.toggleClass("selected", bSelected);
            $.uniform.update();
         }

         return bSelected;
      };

      /**
       * Add the hover state to the surrounding area checkbox
       * 
       */
      this.addHoverSurroundingAreaCheckbox = function (lid) {
         getAreaLabel(lid).addClass("hover");
         $("#uniform-surroundingArea_" + lid).addClass("hover");
         $.uniform.update();
      };

      /**
       * Remove hover state from the surrounding area checkbox
       */
      this.removeHoverSurroundingAreaCheckbox = function (lid) {
         getAreaLabel(lid).removeClass("hover");
         $("#uniform-surroundingArea_" + lid).removeClass("hover");
         $.uniform.update();
      };

      /**
       * GA Tagging: Add surrounding area
       */
      this.gaTrackAddArea = function(strLocationName) {
         var strSearchType = getSearchTypeString(),
            strPrimaryLocation = $("#refineText").val();

         if (strPrimaryLocation !== null && strPrimaryLocation !== "" && strLocationName !== null && strLocationName !== "") {
            track.doEvent("Surrounding Areas", "Add " + strSearchType, strPrimaryLocation + " added " + strLocationName);
         }
      };
      
      /**
       * GA Tagging: Remove surrounding area
       * 
       */
      this.gaTrackRemoveArea = function(strLocationName) {
         var strSearchType = getSearchTypeString(),
            strPrimaryLocation = $("#refineText").val();

         if (strPrimaryLocation !== null && strPrimaryLocation !== "" && strLocationName !== null && strLocationName !== "") {
            track.doEvent("Surrounding Areas", "Remove " + strSearchType, strPrimaryLocation + " removed " + strLocationName);
         }
      };
      
      /**
       * Get the selected surrounding areas
       */
      this.getSelectedSurroundingAreas = function() {
         var aAreas = [];

         $.each(m_oSelectedAreasByLid, function(strLid, area) {
            aAreas.push(strLid);
         });

         return aAreas;
      };

      /**
       * Load the surronding areas
       */
      this.loadSurroundingAreasModal = function() {
         var aParams = ajax.getParameters(),
            strSearchType = getSearchTypeString(),
            strSelectedCities = $("#selectedCities").val() || "",
            strSelectedNeighborhoods = $("#selectedNeighborhoods").val() || "",
            strSelectedZipcodes = $("#selectedZipcodes").val() || "",
            switchAreaSearchType = $("#switchAreaSearchType").val() || "";
         
         $("#searchListCheckBoxes").addClass("loadingAreas").empty();

         //ajax.doViewEngineAjax('flyout', "/surroundingAreas.c21",
         ajax.doViewEngineAjax('flyout', "/surroundingarea/flyout/",
            $.param({
               lid: aParams.lid,
               zoom: 18,
               surroundingSearchType: strSearchType,
               selectedCities: strSelectedCities,
               selectedNeighborhoods: strSelectedNeighborhoods,
               selectedZipcodes: strSelectedZipcodes,
               switchAreaSearchType: switchAreaSearchType,
               submitted: true,
               v: 3
            }), {
               cache: true,
               callback: function () {
                  showSurroundingAreasToolTip();
                  $("#searchListCheckBoxes").removeClass("loadingAreas");
                  initSelectedAreas();
               }
            });
      };

      /**
       * Remove surrounding area from all the search types (not sure which type)
       */
      this.removeAreaFromAllSearchTypes = function(strLid) {
         if (strLid !== null && strLid !== "") {
            var area = m_oSelectedAreasByLid[strLid];
            delete m_oSelectedAreas[area.location];
            delete m_oSelectedAreasByLid[strLid];

            removeStringFromElement($("#selectedCities"), strLid);
            removeStringFromElement($("#selectedNeighborhoods"), strLid);
            removeStringFromElement($("#selectedZipcodes"), strLid);
         }
      };

      this.getCurrentSearchLidType = function() {
         var strSearchType = getSearchTypeString();
         return LID_STRING_LOOKUP[strSearchType];
      };

      this.getSelectionsBox = function(strLid) {
         var iLidType = (strLid) ? self.getLidType(strLid) : self.getCurrentSearchLidType();

         switch (iLidType) {
            case LID_TYPE.TYPE_CITY:
               return $("#selectedCities");

            case LID_TYPE.TYPE_NEIGHBORHOOD:
               return $("#selectedNeighborhoods");

            case LID_TYPE.TYPE_ZIPCODE:
               return $("#selectedZipcodes");

            default:
               return null;
         }
      };

      this.getLidType = function(strLid) {
         var strFirstChar = strLid.substring(0, 1);

         switch (strFirstChar) {
            case "C":
               return LID_TYPE.TYPE_CITY;

            case "Z":
               return LID_TYPE.TYPE_ZIPCODE;

            case "P":
            case "Q":
            case "R":
               return LID_TYPE.TYPE_NEIGHBORHOOD;

            default:
               return null;
         }
      };

      /**
       * Update the current surrounding area selections.
       * 
       */
      this.updateCurrentAreaSelections = function() {
         // Do not update the selected areas if the search type radio is switched
         if ($("#switchAreaSearchType").val() === "Y") {
            return;
         }

         // Get the user selected surrounding areas from the portal params
         var aParams = ajax.getParameters(),
            surroundingAreas = aParams.sa;

         self.clearSurroundingAreas();

         // Clear the surrounding areas selected from the portal parameter
         if (!surroundingAreas) {
            return;
         } else {
            var selectedlocations = surroundingAreas.split(",");
            $.each(selectedlocations, function (idx, loc) {
               if (loc !== null && loc !== "") {
                  addSelectedSurroundingArea(loc);
               }
            });
         }
      };
   };
});
